var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mutant-header"},[_c('div',{staticClass:"mutant-header__title",style:(_vm.titleStyle)},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }